import React from 'react'
import styled from '@emotion/styled'
import { Input, Select, Space } from 'antd'
import {
  PortalArtigoModel,
  PortalRelatedArticlesConfig,
} from '../../../models/PortalArtigoModel'
import { createDefaultRelatedArticles } from '../helpers/artigo-defaults'
import { usePortalPostOptions } from '../helpers/use-portal-editor-reference-options'
import { PortalEditorField } from './PortalEditorField'

interface RelatedArticlesEditorProps {
  value?: PortalRelatedArticlesConfig
  currentArticle: Pick<PortalArtigoModel, 'id' | 'slug'>
  onChange: (value: PortalRelatedArticlesConfig) => void
}

export function RelatedArticlesEditor({
  value,
  currentArticle,
  onChange,
}: RelatedArticlesEditorProps) {
  const relatedArticles = value || createDefaultRelatedArticles()
  const selectedSlugs = relatedArticles.articleSlugs || []
  const { portalPostOptions, loadingArtigos } = usePortalPostOptions(
    selectedSlugs,
    currentArticle
  )

  return (
    <Space direction="vertical" style={{ width: '100%' }}>
      <PortalEditorField label="Título da seção de artigos">
        <Input
          value={relatedArticles.title}
          placeholder="Artigos relacionados"
          onChange={(event) =>
            onChange({ ...relatedArticles, title: event.target.value })
          }
        />
      </PortalEditorField>
      <PortalEditorField label="Artigos relacionados">
        <Select
          mode="multiple"
          allowClear
          showSearch
          loading={loadingArtigos}
          optionFilterProp="label"
          maxTagCount="responsive"
          value={selectedSlugs}
          options={portalPostOptions}
          placeholder="Selecione os artigos relacionados"
          style={{ width: '100%' }}
          onChange={(articleSlugs: string[]) =>
            onChange({ ...relatedArticles, articleSlugs })
          }
        />
      </PortalEditorField>
      <AdvancedFields>
        <summary>Configurações avançadas</summary>
        <PortalEditorField label="ID da âncora dos artigos">
          <Input
            value={relatedArticles.anchorId}
            placeholder="artigos-relacionados"
            onChange={(event) =>
              onChange({ ...relatedArticles, anchorId: event.target.value })
            }
          />
        </PortalEditorField>
      </AdvancedFields>
    </Space>
  )
}

const AdvancedFields = styled.details`
  width: 100%;
  color: #595959;

  summary {
    cursor: pointer;
    color: #595959;
    font-weight: 600;
    margin-bottom: 8px;
  }
`
